import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_RET004_Request,
  IAPI_RET004_Response,
} from "../../../type/apiType";

// 退職手当金請求参照
const httpAPI_RET004 = async (
  param: IAPI_RET004_Request
): Promise<IAPI_RET004_Response> => {
  let res = await http.post(ApiUrl.API_RET004, {
    ...param,
  });
  return res.data;
};
export { httpAPI_RET004 };
